import React from 'react';
import Certain from "../../../../components/Operation/Certain";
import Delay from "../../../../components/Operation/Delay";
import Duration from "../../../../components/Operation/Duration";
import Id from "../../../../components/Operation/Id";
import Locations from '../../../../components/Operation/Locations2';
import Logo from "../../../../components/Operation/Logo";
import NameSpot from "../../../../components/Operation/NameSpot";
import NoteDetail from "../../../../components/Operation/NoteDetail";
import OperationStatus from "../../../../components/Operation/OperationStatus";
import Weather from "../../../../components/Operation/Weather";
import { OP_STATUS, OPERATION_TYPE } from "../../../../util/varibles/constants";
import { IOperation, TOperation2 } from "../../../../util/varibles/interface";
import styles from "./style.module.scss";

interface IProps {
    data: IOperation
    isOwn: boolean
    status: OP_STATUS
}

const SupportView: React.FC<IProps> = ({ data, isOwn, status }) => {
    const { operation, activity_log } = data;

    return <>
        <div className={styles.title}>
            <div className={styles.left}>
                <Logo
                    type={OPERATION_TYPE.SUPPORT}
                    status={status}
                />
                <Id {...{ operation, status }} />
                <OperationStatus {...{ status }} />
                <Certain {...{ operation, status }} />
                <Locations locations={operation.locations || []} separate={', '} />
            </div>
            <div className={styles.right}>
                <Weather {...{ visible: true, operation: operation as TOperation2 }} />
                <Delay visible={true} operation={operation} />
                {!isOwn && <NameSpot {...{ visible: true, operation }} />}
            </div>
        </div>
        <div className={styles.section}>
            <Duration {...{ visible: true, status, activity_log }} />
        </div>
        <NoteDetail operation={operation} visible={true} />
    </>;
};

export default SupportView;
